

import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {ApplicationViewModel, StateFeeRequirementViewModel} from "@/api-client";

@Component({})
export default class StateFeeInfoCard extends Vue {
  @Prop({required: true})
  application!: ApplicationViewModel;

  @Prop({required: true})
  requirement!: StateFeeRequirementViewModel;
}
